"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntimidationOfTheKingEffectHandler = exports.IntimidationOfTheKingEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class IntimidationOfTheKingEffectArgs {
    constructor(attributeDecreases) {
        this.attributeDecreases = attributeDecreases;
        this.__type = EffectType_1.EffectType.IntimidationOfTheKing;
        this.__typeName = "IntimidationOfTheKing";
        this.name = "Intimidation of the King";
        this.harmful = true;
    }
}
exports.IntimidationOfTheKingEffectArgs = IntimidationOfTheKingEffectArgs;
let IntimidationOfTheKingEffectHandler = class IntimidationOfTheKingEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyDebuffs({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effects: state.args.attributeDecreases.map(({ attribute, decrease }) => ({
                effect: new _1.MaxAttributeDecreaseEffectArgs(attribute, decrease),
                duration: Duration_1.Duration.Instant,
            }))
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
IntimidationOfTheKingEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.IntimidationOfTheKing)
], IntimidationOfTheKingEffectHandler);
exports.IntimidationOfTheKingEffectHandler = IntimidationOfTheKingEffectHandler;
